import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { App } from "./App";

const id = `${process.env.ID_PREFIX}home`;
const container = document.getElementById(id);

if (!container) {
  throw new Error(`Could not find container with id: "${id}"`);
}

const root = createRoot(container);
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
